const icon = new URL('../../icons/vehicle.png', import.meta.url).href

export default {
  type: 'vehicle',
  description: 'Vehicle (AGV/Cart)',
  group: 'warehouse' /* line|shape|textAndMedia|chartAndGauge|table|container|dataSource|IoT|3D|warehouse|form|etc */,
  icon,
  model: {
    type: 'vehicle',
    left: 100,
    top: 100,
    width: 120,
    height: 80,
    depth: 40,
    fillStyle: '#888888',
    strokeStyle: '#666',
    lineWidth: 1,
    alpha: 1
  }
}
